window.TabSwitcher = class {
  constructor(rootElement) {
    this.root = document.querySelector(rootElement);
    this.initTabs();
  }

  initTabs() {
    if (!this.root) {
      console.error("Tab root element not found.");
      return;
    }

    this.tabs = this.root.querySelectorAll('[role="tab"]');
    this.panels = this.root.querySelectorAll('[role="tabpanel"]');

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", () => this.switchTab(tab, 'click'));
      tab.addEventListener("keydown", (event) => {
        if (event.key === "ArrowRight") {
          this.showNext();
        }
        if (event.key === "ArrowLeft") {
          this.showPrevious();
        }
      });
    });
  }

  switchTab(selectedTab, method = 'keyboard') {
    this.tabs.forEach((tab) => {
      tab.setAttribute("aria-selected", "false");
      tab.setAttribute("tabindex", "-1");
      this.getPanelForTab(tab).style.display = "none";
    });

    selectedTab.setAttribute("aria-selected", "true");
    selectedTab.setAttribute("tabindex", "0");
    if(method !== "click")
      selectedTab.focus();
    this.getPanelForTab(selectedTab).style.display = "block";
  }

  showPrevious(method = 'keyboard') {
    const currentTabIndex = Array.from(this.tabs).findIndex(
      (tab) => tab.getAttribute("aria-selected") === "true"
    );
    if (currentTabIndex > 0) {
      const previousTab = this.tabs[currentTabIndex - 1];
      this.switchTab(previousTab, method);
    } else {
      const previousTab = this.tabs[this.tabs.length - 1];
      this.switchTab(previousTab, method);
    }
  }

  showNext(method = 'keyboard') {
    const currentTabIndex = Array.from(this.tabs).findIndex(
      (tab) => tab.getAttribute("aria-selected") === "true"
    );
    if (currentTabIndex < this.tabs.length - 1) {
      const nextTab = this.tabs[currentTabIndex + 1];
      this.switchTab(nextTab, method);
    } else {
      const nextTab = this.tabs[0];
      this.switchTab(nextTab, method);
    }
  }

  getPanelForTab(tab) {
    const panelId = tab.getAttribute("aria-controls");
    return this.root.querySelector(`.panels [aria-labelledby="${panelId}"]`);
  }
};
